export default "__VITE_ASSET__BEZBO8Ku__"